import { Button } from '@mui/material'
import { useState } from 'react'
import { SendP2PReminders } from '../../../../services/peerToPeer/DashboardService'
import { handleApiResponse } from '../../../../utils/apiHelpers'
import { toast } from 'react-toastify'

interface Props {
  organizationId: number
  reportingYearId: number
  targetDistrictOrganizationIds?: number[]
}

export const RemindAction = ({ organizationId, reportingYearId, targetDistrictOrganizationIds }: Props): JSX.Element => {
  const [isSending, setIsSending] = useState(false)

  const remind = async (): Promise<void> => {
    setIsSending(true)
    const result = await handleApiResponse(SendP2PReminders({ organizationId, reportingYearId, targetDistrictOrganizationIds }))
    setIsSending(false)
    if (result != null) {
      toast.success(`${result.remindersSent} reminder(s) sent`)
    }
  }

  return (
    <Button
      variant='outlined'
      onClick={() => { void remind() }}
      disabled={isSending}
      data-testid='p2pRemind'
      data-hide-in-pdf
      sx={{ textTransform: 'none' }}
    >
      Send reminders
    </Button>
  )
}
